import React from "react"

import PopupMenuButton from "../../../../../popover-menu/popup-menu-button/popup-menu-button"
import ToolbarMoreButton from "./more-button"
import ToolbarMoreMenu from "./more-menu"
import LexicalEditorLocalSettings from "../../../../settings/local-settings"
import {LexicalEditor} from "lexical"

type Props = {
    editor                  : LexicalEditor
    localSettings           : LexicalEditorLocalSettings

    hideControlsAllowed?    : boolean
}

const debug = false
// const debug = "MoreToolbar"

export default function MoreToolbar(props: Props): JSX.Element {
    const onClickSpeechToText = () => {
        debug && console.log(debug, 'onClickSpeechToText')
    }

    const onClickFullscreen = () => {
        debug && console.log(debug, 'onClickFullscreen')
    }

    return (
        <div className="more-toolbar">
            {/*<ControlButtonStandard  iconClass   = "editor-i5-microphone fs-16"
                                    onClick     = {onClickSpeechToText}/>

            <ControlButtonStandard  iconClass   = "editor-i5-full-size fs-16"
                                    onClick     = {onClickFullscreen}/>*/}

            <PopupMenuButton hint           = "List options"
                             btnComponent   = {ToolbarMoreButton}
                             menuComponent  = {ToolbarMoreMenu}
                             menuParams     = {{
                                 editor             : props.editor,
                                 localSettings      : props.localSettings,
                                 hideControlsAllowed: props.hideControlsAllowed,
                             }}/>
        </div>
    )
}